<template>
  <div>
    <update-patient-profile-modal
      :patient-data="patientData"
      :is-add-active.sync="toggleModal" 
      @refresh="$emit('refresh')"
    />
    
    <add-dietician-appointment-modal 
      :is-add-active.sync="toggleDieticianModal"
      :patient-data="patientData"
      :consultation-data="consultationData"
      resource="appointments"
    />

    <add-doctor-appointment-modal 
      :is-add-active.sync="toggleDoctorModal"
      :patient-data="patientData"
      :consultation-data="consultationData"
      resource="appointments"
    />

    <refer-to-facility-modal 
      :is-add-active.sync="togglePhysicalFacilityModal"
      resource="external_referrals"
    />

    <issue-excuse-duty-modal 
      :patient-data="patientData"
      :is-add-active.sync="toggleExcuseDutyModal"
      resource="excuse_duties"
    />

    <b-dropdown variant="link" class="p-0" no-caret :right="$store.state.appConfig.isRTL">
      <template #button-content>
        <feather-icon icon="MoreVerticalIcon" size="20" class="align-middle text-body" />
      </template>

      <b-dropdown-item v-if="canUpdateUser" @click="toggleModal = true">
        <feather-icon icon="EditIcon" />
        <span class="align-middle ml-50">Edit</span>
      </b-dropdown-item>

      <b-dropdown-item @click="$emit('refresh')">
        <feather-icon icon="RefreshCcwIcon" />
        <span class="align-middle ml-50">Refresh</span>
      </b-dropdown-item>

      <b-dropdown-item @click="showMedicalHistory">
        <feather-icon icon="ActivityIcon" />
        <span class="align-middle ml-50">Medical History</span>
      </b-dropdown-item>

      <b-dropdown-item v-if="currentUserProfession === 'doctor' && can('excuse_duties:CanAddNew')" @click="onExcuseDuty">
        <feather-icon icon="PhoneOffIcon" />
        <span class="align-middle ml-50">Issue Excuse Duty</span>
      </b-dropdown-item>

      <b-dropdown-item v-if="currentUserProfession === 'doctor' && can('external_referrals:CanAddNew')" @click="onPhysicalReferral">
        <feather-icon icon="CornerDownRightIcon" />
        <span class="align-middle ml-50">Refer to Physical Facility</span>
      </b-dropdown-item>

      <b-dropdown-item @click="onDoctorReferral">
        <feather-icon icon="ArrowRightCircleIcon" />
        <span class="align-middle ml-50">Schedule Appointment With a Doctor</span>
      </b-dropdown-item>

      <b-dropdown-item @click="onDieticianReferral">
        <feather-icon icon="ArrowRightCircleIcon" />
        <span class="align-middle ml-50">Schedule Appointment With a Dietician</span>
      </b-dropdown-item>
    </b-dropdown>

    <medical-history-sidebar
    :patient-data="patientData"
    :is-medical-history-sidebar-active.sync="isMedicalHistorySidebarActive"
    />
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BCardHeader,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BBadge,
  BButton,
  BRow,
  BCol,
  BCardImg,
  BLink
} from 'bootstrap-vue';
// import {
//   get,
// } from "lodash";

import Ripple from 'vue-ripple-directive';
import VueEasyLightbox from 'vue-easy-lightbox';

// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UpdatePatientProfileModal from "@core/components/shared/admin/modals/UpdatePatientProfileModal.vue";
import MedicalHistorySidebar from "@core/components/shared/admin/consultation/MedicalHistorySidebar.vue"
import AddDieticianAppointmentModal from "@core/components/shared/admin/modals/AddDieticianAppointmentModal.vue"
import AddDoctorAppointmentModal from "@core/components/shared/admin/modals/AddDoctorAppointmentModal.vue"
import ReferToFacilityModal from "@core/components/shared/admin/modals/ReferToFacilityModal.vue"
import IssueExcuseDutyModal from "@core/components/shared/admin/modals/IssueExcuseDutyModal.vue"


export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BBadge,
    BButton,
    BCardImg,
    BOverlay,
    BCardBody,
    BDropdown,
    BCardHeader,
    BDropdownItem,
    VueEasyLightbox,

    ReferToFacilityModal,
    MedicalHistorySidebar,
    UpdatePatientProfileModal,
    AddDieticianAppointmentModal,
    AddDoctorAppointmentModal,
    IssueExcuseDutyModal,
  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      toggleModal: false,
      toggleDoctorModal: false,
      toggleDieticianModal: false,
      toggleExcuseDutyModal: false,
      togglePhysicalFacilityModal: false,
      isMedicalHistorySidebarActive: false,
    }
  },
  computed: {
    canUpdateUser() {
      return this.can("patients:CanUpdate");
    },
    canDeactivateUser() {
      return this.can("patients:CanDeactivate")
    },
  },
  methods: {
    showMedicalHistory(){
      this.isMedicalHistorySidebarActive = !this.isMedicalHistorySidebarActive;
    },
    onDieticianReferral(){
      this.toggleDieticianModal = true;
    },
    onDoctorReferral(){
      this.toggleDoctorModal = true;
    },
    onPhysicalReferral(){
      this.togglePhysicalFacilityModal = true;
    },
    onExcuseDuty(){
      this.toggleExcuseDutyModal = true;
    }
  }
}
</script>

<style scoped>
.gap {
  gap: 40px;
}

.zero-margin{
  margin: 0px;
}
</style>
